import { Typography, RightArrowIcon, ViewMoreButton } from 'components/UI'

// Same as PullRequestItem, YourTeams, LatestWork
// const HubItem = () => (
// 	<li class='flex items-center space-x-2'>
// 		<HubIcon />
// 		<Link href='/'>
// 			<Typography
// 				class='hover:underline'
// 				color='text-black-100'
// 				text='Welcome to Código Platform'
// 				variant='text3'
// 			/>
// 		</Link>
// 	</li>
// )

type Props = {
	openModal: (title: string, description: string) => void
}

const HubsSection = ({ openModal }: Props) => (
	<div class='rounded-md border border-black-800 bg-black-850 p-5'>
		<Typography
			color='text-black-100'
			text='Hubs'
			variant='h5'
			weight='font-bold'
		/>
		<Typography
			class='mb-6 mt-2'
			color='text-black-200'
			text='Unifies messages from all your smart contracts, keeping everything organized and accessible in one place.'
			variant='text3'
		/>

		{/* <ul class='space-y-2'>
			<HubItem />
		</ul> */}

		<div class='mt-4 flex justify-end'>
			<ViewMoreButton
				icon={
					<RightArrowIcon className='text-black-200 group-hover:text-product' />
				}
				onClick={() =>
					openModal(
						'Hubs',
						'Collaborate with your team in a dedicated space for your dApp. Exchange ideas, chat in real time, and manage your smart contracts together—all in one place. Stay tuned: Hubs is coming soon and will transform the way you work with your team!'
					)
				}
				text='Coming Soon'
			/>
		</div>
	</div>
)

export { HubsSection }
